import {MouseEventHandler, useEffect, useState} from 'react';
import ApiKeyService from '../services/apiKeyService';

import './CSS/ApiKey.css';

const ApiKey: React.FC = () => {
    const [postKey, setPostKey] = useState('');
    const [getKey, setGetKey] = useState('');

    useEffect(() => {
        const apiKeyService = new ApiKeyService();
        const apiKeyPromise = apiKeyService.getApiKey();

        apiKeyPromise.then((result) => {
            if (result !== null) {
                if (result.post_key !== undefined && result.get_key !== undefined) {
                    setPostKey(result.post_key);
                    setGetKey(result.get_key);
                }
            }
        });
    }, []);

    const copyApiKey: MouseEventHandler<HTMLButtonElement> = (event) => {
        const target = event.currentTarget;
        const type = target.getAttribute('data-type');

        if (type === 'post') {
            navigator.clipboard.writeText(postKey);
        } else if (type === 'get') {
            navigator.clipboard.writeText(getKey);
        }
    };

    const updateApiKey = () => {
        const apiKeyService = new ApiKeyService();
        const apiKeyPromise = apiKeyService.updateApiKey();

        apiKeyPromise
            .then((result) => {
                if (result !== null) {
                    if (result.post_key !== undefined && result.get_key !== undefined) {
                        setPostKey(result.post_key);
                        setGetKey(result.get_key);
                    }
                }
            })
            .catch((reson) => {
                console.error(reson);
            });
    };

    return (
        <div id='ApiKeyPage' className='page'>
            <div className='content'>
                <h2>APIキー確認</h2>
                <dl>
                    <dt>post api key</dt>
                    <dd>
                        <input type='text' value={postKey} readOnly></input>
                        <span className='material-symbols-outlined' onClick={copyApiKey} data-type='post'>
                            content_copy
                        </span>
                    </dd>
                    <dt>get api key</dt>
                    <dd>
                        <input type='text' value={getKey} readOnly></input>
                        <span className='material-symbols-outlined' onClick={copyApiKey} data-type='get'>
                            content_copy
                        </span>
                    </dd>
                </dl>
                <h2>APIキー更新</h2>
                <button onClick={updateApiKey}>更新</button>
            </div>
        </div>
    );
};

export default ApiKey;
